<div class="my-list-wrapper-workspaces">
  <app-search-bar
    [placeholder]="searchPlaceholder"
    [tooltip]="searchTooltip"
    (searchChanged)="filterWorkspaces($event)"
  ></app-search-bar>

  <div
      *ngIf="workspaces && workspaces.length > 0; else noConversations"
    >
    <app-data-table
      [data]="filteredWorkspaces"
      [columns]="columns"
      [selectedItem]="selectedWorkspace"
      [presentationMode]="'cards'"
      (rowClicked)="onRowClick($event)"
      (actionClicked)="onActionClick($event)"
    ></app-data-table>
  </div>

  <app-loading-spinner *ngIf="loading"></app-loading-spinner>

  <ng-template #noConversations>
    <app-chat-card
      class="no-conversations-card"
      *ngIf="!loading"
      [header]="''"
      [description]="'You are not a member of any workspaces, please contact support.'"
      [button_label]="'Logout'"
      [route]="'/logout'"
      [showActions]="true"
    >
    </app-chat-card>
  </ng-template>
</div>
